if (!customElements.get('zapiet-picker')) {
  customElements.define(
    'zapiet-picker',
    class TermsConditions extends HTMLElement {
      constructor() {
        const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
        checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions || 0;
        checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
        checkoutBtn.disabled = true;

        if(window.ZapietEvent) {
          window.ZapietEvent.listen('checkoutEnabled', () => {
            checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions - 1;

            if(+checkoutBtn.dataset.awaitingCheckoutConditions === 0) {
              checkoutBtn.disabled = false;
            }
          });
        }
      }
    }
  );
}

